import React, { useRef, useState } from 'react';
import { SparklesStrongIcon } from 'src/monet/icons';
import { trackSegmentEvent } from 'src/utils/segment';
import { useEditorContext } from 'src/store/editor';
import { EditorHeaderAiAssistantPopover } from './ai-assistant-popover';
import { NeueCanvasButton } from 'src/editor/content-creation/components/neue-button/canvas';

export const EditorHeaderAiAssistantButton = () => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const buttonWrapperRef = useRef<HTMLDivElement>(null);
  const { journey } = useEditorContext();

  const handleClick = () => {
    trackSegmentEvent('Editor Insights Clicked', { context: 'ai-assistant' });
    setIsPopoverOpen(!isPopoverOpen);
  };

  const handleClose = () => {
    setIsPopoverOpen(false);
  };

  return (
    <div className="relative" ref={buttonWrapperRef}>
      <NeueCanvasButton
        className="py-[5px] px-2.5 !bg-neue-journey-bg !text-neue-journey-fg"
        type="button"
        onClick={handleClick}
      >
        <div className="flex items-center space-x-[6px] ask-anything-journey">
          <span>Ask anything</span>
          <SparklesStrongIcon />
        </div>
      </NeueCanvasButton>
      {journey && (
        <EditorHeaderAiAssistantPopover
          isOpen={isPopoverOpen}
          onClose={handleClose}
          journey={journey}
          buttonRef={buttonWrapperRef}
        />
      )}
    </div>
  );
}; 